import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {
    }
    // ,public jwtHelper: JwtHelper
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):  boolean {
      const token = localStorage.getItem('userToken');
      // console.log(token);
      if (token != null) {
        // const jwtHelper = new JwtHelper();
        // console.log(jwtHelper.isTokenExpired(token));
        // return !jwtHelper.isTokenExpired(token);
        return true;
    }
      // console.log('canActivate');
      this.router.navigate(['/login']);
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts